import { useEffect, useCallback } from 'react'

export const useKeyboardShortcuts = ({
  isRunning,
  frequency,
  verticalPosition,
  onStart,
  onPause,
  onReset,
  onToggleFullscreen,
  onFrequencyChange,
  onVerticalPositionChange,
  minFrequency = 0.2,
  maxFrequency = 2.0,
  frequencyStep = 0.1,
  maxVerticalPosition = 400,
  verticalStep = 10
}) => {
  const handleKeyDown = useCallback((e) => {
    // Prevent default actions for keys we're using
    if (['Space', 'KeyR', 'KeyF', 'ArrowRight', 'ArrowLeft', 'ArrowUp', 'ArrowDown'].includes(e.code)) {
      e.preventDefault()
    }

    switch (e.code) {
      case 'Space': // Space bar - toggle start/pause
        if (isRunning) {
          onPause()
        } else {
          onStart()
        }
        break

      case 'KeyR': // R key - reset session
        onReset()
        break

      case 'KeyF': // F key - toggle fullscreen
        onToggleFullscreen()
        break

      case 'ArrowRight': // Flèche droite - augmenter la fréquence
        if (frequency < maxFrequency) {
          const newFrequency = Math.min(maxFrequency, frequency + frequencyStep)
          onFrequencyChange(newFrequency)
        }
        break

      case 'ArrowLeft': // Flèche gauche - diminuer la fréquence
        if (frequency > minFrequency) {
          const newFrequency = Math.max(minFrequency, frequency - frequencyStep)
          onFrequencyChange(newFrequency)
        }
        break

      case 'ArrowUp': // Up arrow - move ball up
        const newUpPosition = Math.max(-maxVerticalPosition, verticalPosition - verticalStep)
        onVerticalPositionChange(newUpPosition)
        break

      case 'ArrowDown': // Down arrow - move ball down
        const newDownPosition = Math.min(maxVerticalPosition, verticalPosition + verticalStep)
        onVerticalPositionChange(newDownPosition)
        break
    }
  }, [
    isRunning,
    frequency,
    verticalPosition,
    onStart,
    onPause,
    onReset,
    onToggleFullscreen,
    onFrequencyChange,
    onVerticalPositionChange,
    minFrequency,
    maxFrequency,
    frequencyStep,
    maxVerticalPosition,
    verticalStep
  ])

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown)
    
    return () => {
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [handleKeyDown])

  // Return the shortcuts for documentation
  return {
    shortcuts: {
      'Espace': 'Démarrer/Pause',
      'R': 'Reset',
      'F': 'Plein écran',
      '← →': 'Fréquence',
      '↑ ↓': 'Position verticale'
    }
  }
} 